import { Box, Card, CardContent, Grid, Typography, Button, Toolbar, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PrintIcon from '@mui/icons-material/Print';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PeopleIcon from '@mui/icons-material/People';

const DocumentsPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation("global");
    const theme = useTheme();
    const BASE_PATH = process.env.REACT_APP_BASE_PATH || '';

    const documents = [
        {
            title: t('documents.weeklyExits.title', 'Scheda Uscite Settimanali'),
            description: t('documents.weeklyExits.description', 'Registro cartaceo per orari di uscita e rientro degli ospiti'),
            icon: <ExitToAppIcon sx={{ fontSize: 60, color: 'primary.main' }} />,
            path: '/documents/weekly-exits'
        },
        {
            title: t('documents.weeklyVisits.title', 'Scheda Visite Settimanali'),
            description: t('documents.weeklyVisits.description', 'Registro cartaceo per visite dei parenti'),
            icon: <PeopleIcon sx={{ fontSize: 60, color: 'primary.main' }} />,
            path: '/documents/weekly-visits'
        }
    ];

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                p: 3
            }}
        >
            <Toolbar />
            
            <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
                <PrintIcon sx={{ mr: 2, verticalAlign: 'middle' }} />
                {t('documents.title', 'Documenti Stampabili')}
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                {t('documents.subtitle', 'Genera e stampa registri cartacei per la gestione quotidiana della struttura')}
            </Typography>

            <Grid container spacing={3}>
                {documents.map((doc, index) => (
                    <Grid item xs={12} md={6} key={index}>
                        <Card 
                            sx={{ 
                                height: '100%',
                                cursor: 'pointer',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: 4
                                }
                            }}
                            onClick={() => navigate(`${BASE_PATH}${doc.path}`)}
                        >
                            <CardContent sx={{ textAlign: 'center', p: 4 }}>
                                <Box sx={{ mb: 2 }}>
                                    {doc.icon}
                                </Box>
                                
                                <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                                    {doc.title}
                                </Typography>
                                
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                    {doc.description}
                                </Typography>
                                
                                <Button 
                                    variant="contained" 
                                    color="primary"
                                    startIcon={<PrintIcon />}
                                >
                                    {t('documents.generate', 'Genera Documento')}
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Istruzioni */}
            <Box sx={{ mt: 4, p: 3, backgroundColor: 'background.paper', borderRadius: 2 }}>
                <Typography variant="h6" gutterBottom>
                    ℹ️ {t('documents.howToUse', 'Come utilizzare')}
                </Typography>
                <Typography variant="body2" component="div">
                    <ul style={{ paddingLeft: '20px' }}>
                        <li>{t('documents.instructions.step1', 'Seleziona il tipo di documento da generare')}</li>
                        <li>{t('documents.instructions.step2', 'Scegli la settimana di riferimento')}</li>
                        <li>{t('documents.instructions.step3', 'Il documento verrà generato in formato PDF pronto per la stampa')}</li>
                        <li>{t('documents.instructions.step4', 'Stampa e compila manualmente durante la settimana')}</li>
                    </ul>
                </Typography>
            </Box>
        </Box>
    );
};

export default DocumentsPage;
